<template>
    <div class="container">
        <div>
            <div class="page-content">
                <div class="phone-view">
                    <div class="phone-masker" v-if="swicthIndex == 0" style="flex-direction:column">
                        <div class="phone-maskerimg"
                            :style="{ 'background-image': imageUrl ? '' : `url(${bgImg})`, width: posterSize == '1' ? '250px' : '320px', height: posterSize == '1' ? '300px' : '400px' }">
                            <img v-if="imageUrl" :src="imageUrl" alt="" width="100%" height="100%" />
                        </div>
                        <div style="margin-top:20px" @click="deleteFn">
                            <img style="width:30px;height:30px"
                                src="https://fenxiao.muruji.com/internalSystem/4242b5ff-d7ec-4e8b-b0a4-2f985c48cdec">
                            </img>
                        </div>
                    </div>
                    <div class="fenlei" v-if="swicthIndex == 1">
                        <img src="@/assets/img_biaozhun@2x.png" style="width: 100%;height: 100%;" alt=""
                            v-if="classifyType == '1'">
                        <img src="@/assets/img_biaoqian@2x.png" style="width: 100%;height: 100%;" alt=""
                            v-if="classifyType == '2'">
                    </div>
                    <div class="tabbar" v-if="swicthIndex == 2">
                        <div class="tabbar-item" v-for="(item, index) in navData" :key="index" @click="swicthTabbar(index)">
                            <img :src="tabbarIndex == index ? item.selectedImg : item.unSelectedImg" class="tabbar-icon"
                                alt="" v-if="item.selectedImg && item.unSelectedImg">
                            <div class="tabbar-icon" style="background-color: #d9d9da;" v-else></div>
                            <span :style="{ color: tabbarIndex == index ? (textColor || '#333') : '#999999' }">{{ item.name
                                ||
                                item.typeName }}</span>
                        </div>
                    </div>
                </div>
                <div class="page-right">
                    <div style="display: flex; align-items: center;">
                        <div class="right-title" :class="{ 'right-title-active': swicthIndex == index }"
                            v-for="(item, index) in swicthList" :key="index" @click="swicthFn(index)">{{ item }}</div>
                    </div>
                    <span class="edit-title">内容编辑</span>
                    <div class="line"></div>
                    <div class="edit-top">
                        <div class="edit-name" style="display: flex; align-items: center;">
                            {{ contentTitle }}
                            <span style="color: #909099; font-weight: 500" v-if="swicthIndex == 1 || swicthIndex == 2">{{
                                contentTips
                            }}</span>
                            <div class="edit-name" style="margin-left: 30px;" v-if="swicthIndex == 0">
                                <el-radio v-model="posterSize" label="1">标准尺寸（500*600px）</el-radio>
                                <el-radio v-model="posterSize" label="2">大尺寸（640*800px）</el-radio>
                            </div>
                            <div style="display: flex;align-items: center;margin-left: 30px;" v-if="swicthIndex == 2">
                                <span>选中文字颜色：</span>
                                <el-color-picker v-model="textColor"></el-color-picker>
                                <el-input v-model="textColor" style="width: 200px;margin-left: 30px;"
                                    placeholder="输入颜色值，例：#409EFF"></el-input>
                            </div>
                        </div>
                    </div>
                    <div v-if="swicthIndex == 0">
                        <el-table :data="popData" :header-cell-style="{
                            background: '#F5F6FA',
                            color: '#303033',
                            'font-weight': 'bold',
                            'text-align': 'left',
                        }">
                            <el-table-column label="图片" prop="imgUrl" width="150px">
                                <template slot-scope="scope">
                                    <upload-picture :imageUrl="imageUrl" @getUrl="getImage($event, 1)"></upload-picture>
                                    <!-- <div class="addbox">
                                      <img src="@/assets/icon_add_24hui@2x.png" alt="" class="addicon">
                                  </div> -->
                                </template>
                            </el-table-column>
                            <el-table-column label="关联类型" prop="navType" width="150px">
                                <template slot-scope="scope">
                                    <p v-if="scope.row.navType == 0">-</p>
                                    <p v-if="scope.row.navType == 1">功能跳转</p>
                                    <!-- <p v-if="scope.row.navType == 2">{{ (scope.row.navType == 2 && classifyType == '2' && labelId) ? '分类标签'
                      :
                      '分类类目' }}</p> -->
                                    <p v-if="scope.row.navType == 2">商品</p>
                                    <p v-if="scope.row.navType == 3">页面设置</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="关联页面">
                                <template slot-scope="scope">
                                    <div class="toselect" @click="showDialog">
                                        {{ scope.row.funcName }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100px">
                                <template slot-scope="scope">
                                    <p style="color: #F63C56; cursor: pointer" @click="deleteFn">
                                        删除
                                    </p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="swicthIndex == 1">
                        <el-radio v-model="classifyType" label="1">标准版</el-radio>
                        <el-radio v-model="classifyType" label="2">标签版</el-radio>
                    </div>
                    <div v-if="swicthIndex == 2">
                        <el-table :data="navData" :header-cell-style="{
                            background: '#F5F6FA',
                            color: '#303033',
                            'font-weight': 'bold',
                            'text-align': 'left',
                        }">
                            <el-table-column label="排序" width="80px">
                                <template slot-scope="scope">
                                    <p>{{ scope.$index + 1 }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="选中" width="150px">
                                <template slot-scope="scope">
                                    <upload-picture :imageUrl="scope.row.selectedImg"
                                        @getUrl="getImage($event, 2, scope.$index)"></upload-picture>
                                </template>
                            </el-table-column>
                            <el-table-column label="未选中" width="150px">
                                <template slot-scope="scope">
                                    <upload-picture :imageUrl="scope.row.unSelectedImg"
                                        @getUrl="getImage($event, 3, scope.$index)"></upload-picture>
                                </template>
                            </el-table-column>
                            <el-table-column label="名称" prop="name">
                                <template slot-scope="scope">
                                    <el-input placeholder="请输入名称" v-model="scope.row.name" :maxlength="4"
                                        show-word-limit></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="关联页面" prop="typeName"></el-table-column>
                            <el-table-column label="操作" prop="name">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="toDefault(scope.$index)">恢复默认</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!-- <div class="bottom-box" style="border: none;">
                        <div class="bottom-btn" @click="savePopupWindowTemplate(swicthIndex)">保存</div>
                    </div> -->
                </div>
            </div>

        </div>
        <el-dialog title="功能选择" :append-to-body="true" :visible.sync="dialogVisible" width="898">
            <div class="function-box">
                <div class="function-left">
                    <div class="function-item" :class="{ 'function-item-active': functionIndex == index }"
                        v-for="(item, index) in functionLeft" :key="index" @click="selectFunction(index)">
                        <span>{{ item }}</span>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="function-right">
                    <div class="nopage" v-if="functionIndex == 0">
                        <div class="select-box select-box-active">
                            <el-radio v-model="radio" label="1">不关联页面</el-radio>
                        </div>
                    </div>
                    <div class="nopage" v-if="functionIndex == 1">
                        <div class="select-box" :class="{ 'select-box-active': item.funcId == functionInletRadio }"
                            v-for="item in functionInlet" @click="getFunctionName(item.funcName, item.funcUrl)">
                            <el-radio v-model="functionInletRadio" :label="item.funcId">{{
                                item.funcName
                            }}</el-radio>
                        </div>
                    </div>
                    <!-- 分类标签 -->
                    <div class="nopage" v-show="false">
                        <div style="display: flex; margin-bottom: 30px;">
                            <input type="text" class="search-ipt" v-model="tagName" placeholder="请输入标签名称" />
                            <el-button type="primary" size="mini"
                                style="height: 36px; line-height: normal; margin-left: 18px"
                                @click="getLabelList">查询</el-button>
                        </div>
                        <div class="select-box" :class="{ 'select-box-active': item.id == labelId }"
                            v-for="item in labelList">
                            <el-radio v-model="labelId" :label="item.id">{{
                                item.tagName
                            }}</el-radio>
                        </div>
                        <div class="pagibox" style="position: static;justify-content: center;margin-top: 20px;">
                            <el-pagination @size-change="handleSizeChangeLabel" @current-change="handleCurrentChangeLabel"
                                :current-page="labelPageNo" :page-sizes="[5, 10, 20, 30]" :page-size="labelPageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="labelTotalNum">
                            </el-pagination>
                        </div>
                    </div>
                    <!-- 分类类目 -->
                    <div class="nopage" v-show="false">
                        <div style="display: flex">
                            <input type="text" class="search-ipt" v-model="categoryName" placeholder="请输入类目名称" />
                            <el-button type="primary" size="mini"
                                style="height: 36px; line-height: normal; margin-left: 18px"
                                @click="searchCate">查询</el-button>
                        </div>
                        <div class="categary-box">
                            <div class="categary-item" :class="{ 'categary-active': item.id == rootCategoryId }"
                                v-for="(item, index) in rootCategory" :key="index"
                                @click="swicthRootCate(item.id, item.name)">
                                {{ item.name }}
                            </div>
                        </div>
                        <div style="height: 72%; overflow-y: auto">
                            <div class="select-box" :class="{ 'select-box-active': item.id == categoryId }"
                                v-for="(item, index) in category" :key="item.id" @click="swicthCate(item.id, item.name)">
                                <el-radio v-model="categoryId" :label="item.id">{{
                                    item.name
                                }}</el-radio>
                            </div>
                        </div>
                        <div class="pagibox" style="position: static">
                            <el-pagination @size-change="handleSizeChangecate" @current-change="handleCurrentChangecate"
                                :current-page="catePageNo" :page-sizes="[5, 10, 20, 30]" :page-size="catePageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="cateTotalNum">
                            </el-pagination>
                        </div>
                    </div>
                    <!-- 商品 -->
                    <div class="nopage" style="position: relative; width: 100%; height: 100%" v-if="functionIndex == 2">
                        <div style="display: flex; margin-bottom: 18px">
                            <div class="goods-type-button" :class="{ 'goods-type-active': goodsType == 1 }"
                                @click="selectType(1)">普通商品
                            </div>
                            <div class="goods-type-button" :class="{ 'goods-type-active': goodsType == 2 }"
                                @click="selectType(2)">礼包商品
                            </div>
                            <input type="text" class="search-ipt" v-model="goodsInfo" placeholder="请输入商品名称/商品编号" />
                            <el-button type="primary" size="mini"
                                style="height: 36px; line-height: normal; margin-left: 18px"
                                @click="searchGoods">查询</el-button>
                        </div>
                        <div style="height: 83%; overflow-y: auto">
                            <div class="select-box select-goods" :class="{
                                'select-box-active': item.itemNo == goodsSelectedId,
                            }" v-for="item in goodsList" @click="getGoodsName(item.name)">
                                <el-radio v-model="goodsSelectedId" :label="item.itemNo">
                                    <div class="goods-box">
                                        <img :src="item.mainImg" alt="" class="goods-img" />
                                        <div>
                                            <p>{{ item.name }}</p>
                                            <p class="goods-num">商品编号：{{ item.itemNo }}</p>
                                        </div>
                                    </div>
                                </el-radio>
                            </div>
                        </div>
                        <div class="pagibox" style="position: static">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="goodsPageNo" :page-sizes="[5, 10, 20, 30]" :page-size="goodsPageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
                            </el-pagination>
                        </div>
                    </div>
                    <!-- 页面设置 -->
                    <div class="nopage" v-if="functionIndex == 3">
                        <div style="display: flex; margin-bottom: 30px;">
                            <div class="goods-type-button" :class="{ 'goods-type-active': pageType == 1 }"
                                @click="selectPageType(1)">
                                页面设置
                            </div>
                            <div class="goods-type-button" :class="{ 'goods-type-active': pageType == 2 }"
                                @click="selectPageType(2)">
                                营销活动
                            </div>
                            <input type="text" class="search-ipt" v-model="searchForm.title"
                                :placeholder="pageType == 1 ? '请输入页面标题' : '请输入活动名称'" />
                            <el-button type="primary" size="mini"
                                style="height: 36px; line-height: normal; margin-left: 18px"
                                @click="searchForm.pageNo = 1; getPageList()">查询</el-button>
                        </div>
                        <div class="select-box" :class="{ 'select-box-active': item.id == pageId }"
                            v-for="item in pageList">
                            <el-radio v-model="pageId" :label="item.id">{{
                                item.title || item.name
                            }}</el-radio>
                        </div>
                        <div class="pagibox" style="position: static;justify-content: center;margin-top: 20px;">
                            <el-pagination @size-change="handleSizeChangePage" @current-change="handleCurrentChangePage"
                                :current-page="searchForm.pageNo" :page-sizes="[5, 10, 20, 30]"
                                :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                                :total="pageTotalNum">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmFn">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '@/components/breadcrumb.vue'
import breadcrumbSearch from '@/components/breadcrumbSearch.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        uploadPicture
    },
    props: {
        activityId: Number,
        activityType: String,
    },
    data() {
        return {
            swicthList: ['弹窗页'],
            swicthIndex: 0,
            contentTitle: '弹窗海报设置',
            contentTips: '（图片建议尺寸500*600px）',
            classifyType: '',
            dataList: {
                list: [
                    { title: '商城管理', path: '', type: '0' },
                    { title: '商城装修', path: '', type: '1' }
                ]
            },
            popData: [
                {
                    imgUrl: '',
                    navType: 0,
                    funcName: '不关联页面',
                    navUrl: '',
                    id: '',
                    functionInletRadio: ''
                }
            ],
            dialogVisible: false,
            functionLeft: ['无', '功能入口', '商品', '页面设置'],
            functionIndex: 0,
            radio: '1',
            functionInlet: [
                { label: '1', name: '消息中心' },
                { label: '2', name: '佣金管理' },
                { label: '3', name: '地址管理' },
                { label: '4', name: '银行卡' },
                { label: '5', name: '店铺申请' },
                { label: '6', name: '粉丝管理' },
                { label: '7', name: '联系客服' },
                { label: '8', name: '会员中心' },
                { label: '9', name: '优惠券' },
                { label: '10', name: '订单中心' }
            ],
            functionInletRadio: '',
            imageUrl: '',
            rootCategoryId: '',
            categoryId: '',
            goodsId: '',
            rootCategory: [],
            category: [],
            goodsPageNo: 1,
            goodsPageSize: 10,
            goodsSelectedId: null,
            goodsInfo: '',
            goodsTotalNum: 0,
            goodsList: [],
            catePageNo: 1,
            catePageSize: 10,
            categoryName: '',
            cateTotalNum: 0,
            pageName: '不关联页面',
            navUrl: '',
            bgImg: require('@/assets/img_tanchuang@2x.png'),
            navData: [
                { unSelectedImg: '', selectedImg: '', name: '', typeName: '首页', type: 1 },
                { unSelectedImg: '', selectedImg: '', name: '', typeName: '分类', type: 2 },
                { unSelectedImg: '', selectedImg: '', name: '', typeName: '购物车', type: 3 },
                { unSelectedImg: '', selectedImg: '', name: '', typeName: '我的', type: 4 },
            ],
            labelPageNo: 1,
            labelPageSize: 10,
            tagName: '',
            labelList: [],
            labelId: null,
            labelTotalNum: 0,
            textColor: null,
            tabbarIndex: 0,
            searchForm: {
                title: '', // 	否 	string 	账号名称名称
                status: true,
                createdTimeStart: '',
                createdTimeEnd: '',
                pageNo: 1,
                pageSize: 10
            },
            pageList: [],
            pageTotalNum: 0,
            pageId: null,
            posterSize: '1',
            goodsType: 1,
            pageType: 1,
        }
    },
    created() {
        if (this.activityType == 'edit') {
            this.getPopupWindowTemplate()
        }

        this.getFunctionList()
        this.getGoodsPage()
        // this.getFuncList()

        // this.getGoodsPage()
        // this.getLayoutType()
        // this.navigationBarList()
        // this.getLabelList()
        this.getPageList()
    },
    methods: {
        selectPageType(type) {
            this.pageType = type
            this.searchForm.pageNo = 1;
            this.getPageList()
        },
        selectType(type) {
            this.goodsType = type
            this.goodsPageNo = 1;
            this.getGoodsPage()
        },
        //获取商品列表
        getGoodsPage() {
            let data = {
                pageNo: this.goodsPageNo,
                pageSize: this.goodsPageSize,
                selectedId: '',
                goodsInfo: this.goodsInfo,
                goodsType: this.goodsType
            }
            this.axios.post('/goods/GoodsOrGiftPageListForSelect', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.goodsList = res.data.list;
                        this.goodsTotalNum = res.data.totalNum;
                    }
                })
        },
        getFunctionList() {
            this.axios.get('/indexTemplate/getFuncList')
                .then(res => {
                    console.log('功能列表==', res)
                    if (res.code == 0) {
                        this.functionInlet = res.data
                    }
                })
        },
        getPageList() {
            let url = '/appIndex/pageList'
            if (this.pageType == 1) {
                url = '/appIndex/pageList'
                this.searchForm.status = true
            } else {
                url = '/marketActivate/pageList'
                this.searchForm.name = this.searchForm.title;
                this.searchForm.status = 1;
            }
            this.axios.post(url, this.searchForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.pageList = res.data.list;
                        this.pageTotalNum = res.data.totalNum;
                    }
                })
        },
        handleSizeChangePage(e) {
            this.searchForm.pageSize = e;
            this.searchForm.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChangePage(e) {
            this.searchForm.pageNo = e;
            this.getPageList()
        },
        swicthTabbar(index) {
            this.tabbarIndex = index;
        },
        getLabelList() {
            let data = {
                pageNo: this.labelPageNo,
                pageSize: this.labelPageSize,
                tagName: this.tagName,
                status: true
            }
            this.axios.post('/tags/pageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.labelList = res.data.list;
                        this.labelTotalNum = res.data.totalNum
                    }
                })
        },
        navigationBarList() {
            this.axios.get('/sys/navigationBar/list')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.navData = res.data
                        this.textColor = this.navData[0].color
                    }
                })
        },
        getLayoutType() {
            this.axios.get('/sys/index/getLayoutType')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.classifyType = res.data + '';
                        if (this.classifyType == '1') {
                            this.functionLeft[2] = '分类类目'
                        } else if (this.classifyType == '2') {
                            this.functionLeft[2] = '分类标签'
                        }
                    }
                })
        },
        swicthFn(idx) {
            this.swicthIndex = idx;
            if (idx == 0) {
                this.contentTitle = '弹窗海报设置';
                this.contentTips = '（图片建议尺寸500*600px）';
                this.getLayoutType()
            } else if (idx == 1) {
                this.contentTitle = '分类页设置';
                this.contentTips = '选择页面排版样式';
            } else {
                this.contentTitle = '底部导航栏';
                this.contentTips = '（图片建议128*128px）';
            }
        },
        toDefault(index) {
            this.$confirm('是否确认恢复默认？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.navData[index].unSelectedImg = null;
                this.navData[index].selectedImg = null;
                this.navData[index].name = null;
                this.navData = JSON.parse(JSON.stringify(this.navData))
                this.$forceUpdate()
                this.navigationBarSave()
            }).catch(() => { });
        },
        deleteFn() {
            this.$confirm('是否确认删除？删除后不可恢复数据！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.imageUrl = '',
                    this.popData[0].navType = 0;
                this.popData[0].funcName = '不关联页面';
                this.popData[0].functionInletRadio = '';
                this.functionInletRadio = '';
                this.rootCategoryId = '';
                this.categoryId = '';
                this.goodsId = ''
                this.savePopupWindowTemplate(5)
            }).catch(() => { });
        },
        getFunctionName(name, url) {
            this.pageName = name;
            this.popData[0].navUrl = url
        },
        getGoodsName(name) {
            this.pageName = name.substring(0, 8) + '...'
        },
        handleSizeChangecate(e) {
            this.catePageSize = e;
            this.catePageNo = 1;
            this.getCategoryList()
        },
        handleCurrentChangecate(e) {
            this.catePageNo = e;
            this.getCategoryList()
        },
        handleSizeChangeLabel(e) {
            this.labelPageSize = e;
            this.labelPageNo = 1;
            this.getLabelList()
        },
        handleCurrentChangeLabel(e) {
            this.labelPageNo = e;
            this.getLabelList()
        },
        handleSizeChange(e) {
            this.goodsPageNo = 1;
            this.goodsPageSize = e;
            this.getGoodsPage()
        },
        handleCurrentChange(e) {
            this.goodsPageNo = e;
            this.getGoodsPage()
        },
        searchGoods() {
            this.goodsPageNo = 1;
            this.getGoodsPage()
        },
        getPopupWindowTemplate() {
            let data = {
                type: '2',
                activityId: this.activityId
            }
            this.axios.post('/indexTemplate/get', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.pid = res.data.id;
                        let modelJson = JSON.parse(res.data.modelJsonStr)
                        if (modelJson != '' && modelJson != '{}' && modelJson != null) {
                            console.log(modelJson)
                            this.popData[0].navType = modelJson.navType || 0;
                            this.popData[0].functionInletRadio = modelJson.functionInletRadio || '';
                            this.popData[0].funcName = modelJson.funcName || '不关联页面';
                            this.rootCategoryId = modelJson.rootCategoryId || '';
                            this.categoryId = modelJson.categoryId || '';
                            this.goodsSelectedId = modelJson.goodsId || '';
                            this.imageUrl = modelJson.imageUrl || '';
                            this.functionIndex = modelJson.functionIndex || 0;
                            this.functionInletRadio = modelJson.functionInletRadio || '';
                            this.labelId = modelJson.labelId || null;
                            this.pageId = modelJson.pageId || null;
                            this.posterSize = modelJson.posterSize || '1'
                            this.popData[0].navUrl = modelJson.navUrl || ''
                            console.log('popData', this.popData)
                        }

                    }
                })
        },
        savePopupWindowTemplate(type) {
            if (type == 0) {
                let data = {
                    navType: this.popData[0].navType,//功能选择：0-无，1-功能入口，2，分类类目，3、商品
                    navUrl: this.popData[0].navUrl,//跳转链接
                    functionInletRadio: this.functionInletRadio,//功能入口
                    // rootCategoryId: this.classifyType == '1' ? this.rootCategoryId : '', //父级分类id
                    // categoryId: this.classifyType == '1' ? this.categoryId : '', //子级分类id
                    goodsSelectedId: this.goodsSelectedId,
                    funcName: this.popData[0].funcName,
                    imageUrl: this.imageUrl,
                    // labelId: this.classifyType == '2' ? this.labelId : '',
                    pageType: this.pageType,
                    pageId: this.pageId,
                    posterSize: this.posterSize
                }
                if (type == 5) {
                    data = {}
                }
                let postData = {
                    activityId: this.activityId,
                    modelJsonStr: JSON.stringify(data),
                    type: '2'
                }
                this.axios.post('/indexTemplate/save', postData)
                    .then(res => {
                        console.log(res)
                        if (res.code == 0) {
                            this.getPopupWindowTemplate()
                            if (type == 5) return
                            // this.$message.success('保存成功')
                        } else {
                            // this.$message.warning(res.message)
                        }
                    })
            }
            // if (type == 1) {
            //   if (this.classifyType == '') {
            //     return this.$message.warning('请选择页面排版样式')
            //   }
            //   this.updateLayoutType()
            // }
            // if (type == 2) {
            //   this.navigationBarSave()
            // }
        },
        navigationBarSave() {
            // let list = this.navData.map(item=>{
            //   if(item.name && item.selectedImg && item.unSelectedImg){
            //     return{
            //       name:item.name,
            //       type:item.type,
            //       selectedImg:item.selectedImg,
            //       unSelectedImg:item.unSelectedImg
            //     }
            //   }

            // })
            let data = {
                bottomNavigationBarList: this.navData,
                color: this.textColor
            }
            this.axios.post('/sys/navigationBar/save', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('保存成功')
                    }
                })
        },
        updateLayoutType() {
            this.axios.post('/sys/index/updateLayoutType', { layoutType: this.classifyType })
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('保存成功')
                    }
                })
        },
        swicthCate(id, name) {
            this.pageName = name;
        },
        swicthRootCate(id, name) {
            this.rootCategoryId = id;
            this.catePageNo = 1;
            this.getCategoryList()
        },
        getRootCategoryList() {
            this.axios.get('/sys/index/getRootCategoryList?selectedId=' + this.rootCategoryId)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        let list = res.data;
                        let idx = list.findIndex(item => item.selected)
                        this.rootCategoryId = this.rootCategoryId ? this.rootCategoryId : list[0].id;
                        this.rootCategory = list;
                        this.getCategoryList()
                    }
                })
        },
        searchCate() {
            this.catePageNo = 1;
            this.getCategoryList()
        },
        getCategoryList() {
            let data = {
                pageNo: this.catePageNo,
                pageSize: this.catePageSize,
                parentId: this.rootCategoryId,
                selectedId: this.categoryId,
                categoryName: this.categoryName
            }
            this.axios.post('/sys/index/getCategoryList', data)
                .then(res => {
                    console.log('555', res)
                    let list = res.data.list;
                    let idx = list.findIndex(item => item.selected)
                    if (idx > -1) {
                        this.categoryId = list[idx].id;
                    }
                    this.category = list;
                    this.cateTotalNum = res.data.totalNum;
                    console.log(this.category)
                })
        },
        getFuncList() {
            this.axios.get('/sys/index/getFuncList?selectedId=1')
                .then(res => {
                    console.log(res)
                })
        },
        getImage(url, idx, rowIndex) {
            console.log(url, idx, rowIndex)
            if (idx == 1) {
                this.imageUrl = url;
            } else if (idx == 2) {
                this.navData[rowIndex].selectedImg = url
            } else {
                this.navData[rowIndex].unSelectedImg = url
            }

        },
        selectFunction(idx) {
            this.functionIndex = idx;
            if (idx == 0) {
                this.pageName = '不关联页面'
            }

        },
        showDialog() {
            console.log(this.popData)
            this.dialogVisible = true;
            this.functionIndex = this.popData[0].navType;//功能选择：0-无，1-功能入口，2，分类类目，3、商品
            // let data = {
            //   functionIndex: this.popData[0].navType,//功能选择：0-无，1-功能入口，2，分类类目，3、商品
            //   functionInletRadio: this.functionInletRadio,//功能入口
            //   rootCategoryId: this.rootCategoryId, //父级分类id
            //   categoryId: this.categoryId, //子级分类id
            //   goodsId: this.goodsSelectedId,
            //   funcName: this.popData[0].funcName,
            //   imageUrl: this.imageUrl
            // }
            if (this.functionIndex == 0) {
                this.functionInletRadio = '';
                this.rootCategoryId = '';
                this.categoryId = '';
                this.goodsSelectedId = '';
            } else if (this.functionIndex == 1) {
                this.rootCategoryId = '';
                this.categoryId = '';
                this.goodsSelectedId = '';
            } else if (this.functionIndex == 2) {
                this.functionInletRadio = '';
                this.goodsSelectedId = '';
            } else {
                this.functionInletRadio = '';
                this.rootCategoryId = '';
                this.categoryId = '';
            }
            // this.pageName = this.popData[0].funcName;
        },
        confirmFn() {
            let funcName = '无';
            let rootCategoryId = '';
            let categoryId = '';
            let goodsSelectedId = '';
            let navUrl = '';
            if (this.functionIndex == 0) {
                funcName = '无'
            } else if (this.functionIndex == 1) {
                funcName = this.pageName;
                navUrl = this.navUrl;
            } else if (this.functionIndex == 2) {
                goodsSelectedId = this.goodsSelectedId;
                this.goodsList.forEach((item) => {
                    if (this.goodsSelectedId === item.itemNo) {
                        funcName = item.name.substring(0, 8) + '...'
                    }
                })
                // funcName = this.pageName;
            } else if (this.functionIndex == 3) {
                console.log('55555555555')
                this.pageList.forEach((item) => {
                    if (this.pageId === item.id) {
                        funcName = item.title || item.name
                    }
                })
            }
            this.popData[0].navType = this.functionIndex;
            this.popData[0].funcName = funcName;
            this.dialogVisible = false;
        },
        handleClose(e) {
            this.dialogVisible = false
        },
        toPage() {
            this.$router.push('./indexRenovation')
        }
    }
}
</script>
<style lang="scss" scoped>
input[type="text"],
input[type="number"] {
    -webkit-appearance: none;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #d8dce5;
    box-sizing: border-box;
    color: #5a5e66;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 1;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;

    &:hover {
        border-color: #b4bccc;
    }

    &:focus {
        border-color: #409EFF;
        outline: 0;
    }
}

.bread-small {
    font-size: 16px;
}

.bread-active {
    color: black;
    border-bottom: 2px solid #2d46ee;
}

.page-content {
    width: 100%;
    display: flex;
    margin-top: 20px;
}

.phone-view {
    width: 375px;
    height: 667px;
    background: #fff;
    border-radius: 16px;
    margin-right: 56px;
    position: relative;
    background-image: url('https://fenxiao.muruji.com/internalSystem/66b20472-c0d9-4acb-bbb8-e292c93b5ded');
    background-size: contain;
    background-repeat: no-repeat;
    overflow: hidden;
}

.phone-masker {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.phone-maskerimg {
    width: 250px;
    height: 300px;
    /* background-image: url(@/assets/img_tanchuang@2x.png); */
    background-repeat: no-repeat;
    background-size: contain;
}

.page-right {
    width: 1000px;
}

.right-title {
    width: 92px;
    height: 36px;
    background: #fff;
    border-radius: 3px;
    font-size: 16px;
    margin-bottom: 40px;
    text-align: center;
    line-height: 36px;
    color: white;
    color: #2d46ee;
    border: 1px solid #2d46ee;
    margin-right: 40px;
    cursor: pointer;
}

.right-title:hover {
    background: #2d46ee;
    color: white;
}

.right-title-active {
    background: #2d46ee;
    color: white;
}

.edit-title {
    font-size: 16px;
    color: #303033;
    font-weight: bold;
}

.line {
    width: 100%;
    height: 1px;
    background-color: #c0c0cc;
    margin: 18px auto;
}

.edit-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
}

.edit-name {
    font-size: 14px;
    font-weight: bold;
}

/* .addbox {
      width: 64px;
      height: 64px;
      background: #FFFFFF;
      border: 1px solid #C0C0CC;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 20px;
  } */

.addicon {
    width: 24px;
    height: 24px;
}

.el-table th>.cell {
    font-size: 14px !important;
    text-align: left !important;
    /* padding-left: 30px !important; */
}

.el-table td {
    text-align: left !important;
}

.toselect {
    width: 442px;
    height: 32px;
    background: #e9ecfe;
    border-radius: 3px;
    line-height: 32px;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #2d46ee;
}

.el-dialog__header {
    border-bottom: none;
}

.el-dialog__body {
    padding-top: 18px;
}

.function-box {
    width: 100%;
    height: 557px;
    display: flex;
    color: #303033;


}

/deep/ .el-radio {
    color: #303033;
}

.function-left {
    width: 198px;
    height: 64px;
    background: #ffffff;
}

.function-right {
    flex: 1;
    height: 557px;
    background: #ffffff;
    border: 1px solid #e9ecfe;
    padding: 18px;
    box-sizing: border-box;
}

.function-item {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    box-sizing: border-box;
    font-size: 16px;
}

.function-item-active {
    background-color: #e9ecfe;
    color: #2d46ee;
}

.select-box {
    width: 100%;
    height: 48px;
    background: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 18px;
    box-sizing: border-box;
}

.select-box-active {
    background: #e9ecfe;
}

.search-ipt {
    flex: 1 !important;
    /* width: 518px !important; */
    height: 36px !important;
    background: #ffffff;
    border: 1px solid #c0c0cc;
    border-radius: 3px;
}

.categary-box {
    width: 678px;
    overflow-x: auto;
    white-space: nowrap;
    margin-top: 18px;
    padding-bottom: 18px;
}

.categary-item {
    padding: 8px 15px;
    background-color: #e9ecfe;
    font-size: 14px;
    margin-right: 18px;
    display: inline-block;
    cursor: pointer;
}

.categary-active {
    background-color: #2d46ee;
    color: white;
}

.select-goods {
    height: 72px;
}

.select-goods .el-radio {
    display: flex;
    align-items: center;
}

.goods-box {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.goods-img {
    width: 48px;
    height: 48px;
    background: #d1d1d1;
    margin-right: 8px;
}

.goods-num {
    color: #606066;
    margin-top: 10px;
}

.pagibox {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 6px;
    right: 0;
}

.nopage {
    height: 100%;
    overflow-y: auto;
}

.bottom-box {
    width: 100%;
    height: 88px;
    border-top: 1px solid #ebebfa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
}

.bottom-btn {
    width: 184px;
    height: 40px;
    background: #2d46ee;
    border-radius: 3px;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.tabbar {
    width: 100%;
    height: 58px;
    border-top: 1px solid #ebeaea;
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    box-sizing: border-box;
    font-size: 12px;
    color: #999999;
}

.tabbar-item {
    width: 25%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.tabbar-icon {
    width: 28px;
    height: 28px;
}

.fenlei {
    width: 373px;
    height: 576px;
    // background-color: #2d46ee;
    margin-top: 88px;
    margin-left: 1px;
}

.goods-type-button {
    width: 80px;
    height: 35px;
    font-size: 12px;
    color: #060606;
    text-align: center;
    line-height: 35px;
    border: 1px solid #d7d7d8;
    border-radius: 4px;
    box-sizing: border-box;
    margin-right: 30px;
    cursor: pointer;
    background-color: white;
}

.goods-type-active {
    background-color: #2d46ee;
    color: white;
}
</style>